import { useQuery } from 'react-query';

import { VinovestNetworkingHelper } from '~/helpers/VinovestNetworkingHelper';

/** Returns raw payment method data */
export const usePlaidLinkToken = (portfolioId: string) => {
    return useQuery(
        ['plaidLinkToken', portfolioId],
        async () => {
            const { managed } = VinovestNetworkingHelper.getClient();
            const linkToken = await managed?.getPlaidLinkToken(portfolioId);

            return linkToken.data?.token;
        },
        { staleTime: 1000 * 60 * 1, refetchOnReconnect: true, refetchOnMount: true, refetchOnWindowFocus: true }
    );
};
